<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<mat-card>
    <mat-card-content fxLayout="column">
        <mat-radio-group name="selectRadioGroup"
                         [ngModel]="selectionMode$|async"
                         (ngModelChange)="setSelectionMode($event)"
                         fxLayout="column">
            <mat-radio-button *ngFor="let mode of selectionModes"
                              value="{{ mode }}">{{ mode }}</mat-radio-button>
        </mat-radio-group>
    </mat-card-content>
    <mat-card-actions fxLayoutAlign="center center">
        <button mat-button (click)="close()">Done</button>
    </mat-card-actions>
</mat-card>
